import React, { Component } from "react";
import List from "./List";

export default class Footer extends Component {
  state = {
    contacts: [
      {
        text:
          "РК, г. Алматы, Ауэзовский район, 050062, мкр. 4, дом 14",
        icon: "PIN",
        default: true
      },
      { text: "+7 701 037 8388", icon: "TEL", phone: true },
      { text: "ilyas.bekkuliyev@uvision.kz", icon: "MAIL", email: true },
      { text: "sales@uvision.kz", icon: "MAIL", email: true }
    ]
  };

  render() {
    return (
      <footer className="footer has-background-black-bis">
        <div className="content">
          <div className="columns">
            <div className="column is-4">
              <h3 className="has-text-light has-text-left">Контакты</h3>
              <List data={this.state.contacts} />
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
